import {
  CreateSubscriptionData,
  IsPremiumCache,
  UpdateSubscriptionRequest,
  UpdateSubscriptionResponse,
  eSubscriptionStatus,
} from "../@types/Billing/Subscription";
import { create, update as updatePlan } from "../services/billing/subscription";
import { isPremium } from "../services/billing/subscription/isPremium";
import CacheService from "../services/cache/CacheService";

export default function useSubscription() {
  async function createNew(
    data: CreateSubscriptionData
  ): Promise<eSubscriptionStatus> {
    const status = await create(data);

    if (status === 201) {
      return eSubscriptionStatus.CREATED;
    } else if (status === 409) {
      return eSubscriptionStatus.ALREADY_EXISTS;
    } else if (status === 402) {
      return eSubscriptionStatus.PAYMENT_FAILED;
    }

    return eSubscriptionStatus.UNKNOWN_ERROR;
  }

  /**
   * Determines if user is actually premium from API, cache results for 6H for better performance.
   */
  async function determineIsPremium(): Promise<boolean> {
    const keyName = "is_premium_valid";
    const cacheService = new CacheService();
    const cachedValue = cacheService.get<IsPremiumCache>(keyName, true);

    if (cachedValue) {
      return cachedValue.is_premium;
    } else {
      const responseFromAPI = await isPremium();

      const newCacheData: IsPremiumCache = {
        is_premium: responseFromAPI,
      };
      cacheService.set(keyName, JSON.stringify(newCacheData), 360);

      return responseFromAPI;
    }
  }

  async function determineIsUserPremiumUncached(): Promise<boolean> {
    return isPremium();
  }

  async function update(
    data: UpdateSubscriptionRequest
  ): Promise<UpdateSubscriptionResponse> {
    return updatePlan(data);
  }

  return {
    createNewSubscription: createNew,
    updateSubscription: update,
    isUserPremium: determineIsPremium,
    isUserPremiumUncached: determineIsUserPremiumUncached,
  };
}
